import appendQuery from "append-query"
import { pipeline } from "fgr-lib-business-logic/lib/common/functional"
import { Router as RouterProps } from "next/dist/client/router"
import { NextRouter } from "next/router"
import { replace, keys, map, reject, isNil } from "ramda"
import { Maybe } from "../graphql/generated-types"
import { getRouterQuery } from "./router"

export const getCanonicalUrl = (input: string): string => "https://" + replace(/https{0,1}:\/\//, "", input)

export const objectToUrlParams = (data: Record<string, Maybe<string | number | boolean>>): string =>
    pipeline(
        data,
        keys,
        map((key) => {
            const value = data[key]
            if (value) {
                return `${key}=${encodeURIComponent(value + "")}`
            }
            return null
        }),
        reject(isNil)
    ).join("&")

export const appendParamToUrl = (url: string, key: string, value: string) => {
    const param = objectToUrlParams({ [key]: value })
    return appendQuery(url, param)
}

/* Persisting queries in url */

const TABLE_ID_QUERY = "table"
export const persistUrlQueries = (router: RouterProps | NextRouter, pathUrl: string) => {
    let newUrl = pathUrl
    const currentUrl = router.asPath
    const persistQueriesList = [TABLE_ID_QUERY]

    const containsQueries = persistQueriesList.filter((q) => currentUrl.includes(q))
    if (containsQueries.length > 0) {
        containsQueries.forEach((queryName) => {
            const queryValue = getRouterQuery(router, queryName)
            if (queryValue) {
                newUrl = appendParamToUrl(newUrl, queryName, queryValue)
            }
        })
    }
    return newUrl
}

export const isTableOrderingMode = (router: RouterProps | NextRouter): boolean => {
    return !!getTableOrderingId(router)
}

export const getTableOrderingId = (router: RouterProps | NextRouter): Maybe<string> => {
    return getRouterQuery(router, TABLE_ID_QUERY)
}
